import type { Nullable } from '../../../types';
import { Token } from '../../../entities';
import { TokenStorage } from '../tokenStorage';
import CookiesActions, { CookiesKeys } from '../../cookiesActions';

export default class TokenStorageImpl implements TokenStorage {
  accessToken: Nullable<string> = null;

  getAccessToken(): Nullable<string> {
    return this.accessToken;
  }

  // eslint-disable-next-line class-methods-use-this
  getRefreshToken(): Nullable<string> {
    return CookiesActions.getItem(CookiesKeys.refreshToken);
  }

  saveToken(token: Token): void {
    if (token.refreshToken != null) {
      // const isSecure: boolean = process.env.NODE_ENV === 'production';
      const isSecure = false;
      CookiesActions.setItem(CookiesKeys.refreshToken, token.refreshToken, {
        expires: 14,
        secure: isSecure,
      });
    }

    this.accessToken = token.accessToken;
  }

  deleteToken(): void {
    CookiesActions.deleteItem(CookiesKeys.refreshToken);
    this.accessToken = null;
  }
}
